(() => {
  const modes = {
    mpn: { placeholder: 'Search by part number, e.g. GD32F303CCT6' },
    keyword: { placeholder: 'Search by function, e.g. USB-C controller' },
    manufacturer: { placeholder: 'Search a manufacturer, e.g. Texas Instruments' },
    category: { placeholder: 'Search a category, e.g. Power IC' },
  };

  const quoteTerm = (value) => value.replace(/["\\]/g, '').trim();

  const init = (form) => {
    if (form.dataset.searchModeReady === 'true') return;
    const input = form.querySelector('input[name="q"]');
    const modeInput = form.querySelector('input[name="search_mode"]');
    const tabs = [...form.querySelectorAll('[data-search-mode-tab]')];
    if (!input || !modeInput || !tabs.length) return;

    form.dataset.searchModeReady = 'true';
    const requestedMode = new URLSearchParams(window.location.search).get('search_mode');
    const validMode = modes[requestedMode] ? requestedMode : (modeInput.value || 'mpn');

    const setMode = (mode) => {
      const selected = modes[mode] ? mode : 'mpn';
      modeInput.value = selected;
      input.placeholder = modes[selected].placeholder;
      tabs.forEach((tab) => {
        const active = tab.dataset.searchModeTab === selected;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    setMode(validMode);
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        setMode(tab.dataset.searchModeTab);
        input.focus();
      });
    });

    form.addEventListener('submit', () => {
      const raw = input.value.trim();
      if (!raw) return;
      const mode = modeInput.value;
      const safe = quoteTerm(raw);
      if (mode === 'manufacturer') {
        input.value = `vendor:"${safe}"`;
      } else if (mode === 'category') {
        input.value = `product_type:"${safe}"`;
      } else {
        input.value = safe;
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-ics-search-mode-form]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
